import YellowExclamationAnimatedIcon from "@/Shared/Animations/YellowExclamationAnimatedIcon";

interface BookShipmentWarningMessagesProps {
  /** Each warning is a group of message lines */
  warnings: string[][];
}

export function BookShipmentWarningMessages({
  warnings,
}: BookShipmentWarningMessagesProps) {
  return (
    <div
      style={{
        columnGap: "10px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <YellowExclamationAnimatedIcon />
      {warnings.map((warningLines) => (
        <div key={warningLines.join("|")} style={{ marginBlock: "2px" }}>
          {warningLines.map((line) => (
            <p style={{ padding: 0, margin: 0 }} key={line}>
              {line}
            </p>
          ))}
        </div>
      ))}
    </div>
  );
}
